"use client";

import { useMemo } from "react";
import DocumentLayout from "../(components)/DocumentLayout";

const PrivacyPolicy = ({ params }: any) => {
  const navigationItems = useMemo(
    () => [
      { id: "I", title: "Informationen über uns als Verantwortliche" },
      { id: "II", title: "Rechte der Nutzer und Betroffenen" },
      { id: "III", title: "Informationen zur Datenverarbeitung" },
      { id: "cookies", title: "Cookies" },
      { id: "contact", title: "Kontaktanfragen / Kontaktmöglichkeit" },
      { id: "account", title: "Kundenkonto / Registrierungsfunktion" },
      {
        id: "jobs",
        title:
          "Online-Stellenbewerbungen / Veröffentlichung von Stellenanzeigen",
      },
      { id: "server", title: "Serverdaten" },
      { id: "linkedin", title: "LinkedIn" },
      { id: "analytics", title: "Google Analytics" },
      { id: "cloudflare", title: "CloudFlare" },
      { id: "fonts", title: "Google Fonts" },
      { id: "maps", title: "Google-Maps" },
      { id: "mapbox", title: "Mapbox API" },
      { id: "osm", title: "OpenStreetMap" },
      { id: "whatsapp", title: "WhatsApp" },
    ],
    [],
  );

  return (
    <DocumentLayout
      params={params}
      titleKey="privacy-policy"
      navigationItems={navigationItems}
      basePath="/privacy-policy-new"
    >
          <div className="flex flex-col items-start lg:flex-row gap-8">
            <div className="full flex flex-col gap-6">
              <p>
                Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt)
                werden von uns nur im Rahmen der Erforderlichkeit sowie zum
                Zwecke der Bereitstellung eines funktionsfähigen und
                nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte
                und der dort angebotenen Leistungen, verarbeitet.
              </p>
              <p>
                Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der
                Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt),
                gilt als „Verarbeitung“ jeder mit oder ohne Hilfe
                automatisierter Verfahren ausgeführter Vorgang oder jede solche
                Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie
                das Erheben, das Erfassen, die Organisation, das Ordnen, die
                Speicherung, die Anpassung oder Veränderung, das Auslesen, das
                Abfragen, die Verwendung, die Offenlegung durch Übermittlung,
                Verbreitung oder eine andere Form der Bereitstellung, den
                Abgleich oder die Verknüpfung, die Einschränkung, das Löschen
                oder die Vernichtung.
              </p>
              <p>
                Mit der nachfolgenden Datenschutzerklärung informieren wir Sie
                insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage
                der Verarbeitung personenbezogener Daten, soweit wir entweder
                allein oder gemeinsam mit anderen über die Zwecke und Mittel der
                Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend
                über die von uns zu Optimierungszwecken sowie zur Steigerung der
                Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch
                Dritte Daten in wiederum eigener Verantwortung verarbeiten.
              </p>
              <div>
                <div className="mb-3">
                  Unsere Datenschutzerklärung ist wie folgt gegliedert:
                </div>
                <div className="flex flex-col items-start gap-2">
                  <a
                    target="_blank"
                    href="#I"
                    className="link-primary"
                  >
                    1. Informationen über uns als Verantwortliche
                  </a>
                  <a
                    target="_blank"
                    href="#II"
                    className="link-primary"
                  >
                    2. Rechte der Nutzer und Betroffenen
                  </a>
                  <a
                    target="_blank"
                    href="#III"
                    className="link-primary"
                  >
                    3. Informationen zur Datenverarbeitung
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div id="I" className="flex flex-col items-start lg:flex-row gap-8">
            <div className="w-full flex flex-col gap-6">
              <div>
                <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
                  Informationen über uns als Verantwortliche
                </h2>
                <div>
                  Verantwortlicher Anbieter dieses Internetauftritts im
                  datenschutzrechtlichen Sinne ist:
                </div>
                <ul className="list-disc pl-7">
                  <li>OMTO GmbH</li>
                  <li>Kitzingstraße 15-19</li>
                  <li>12277 Berlin</li>
                </ul>
              </div>
              <div>
                <div>E-Mail: Kontakt Omto DE</div>
                <div>Datenschutzbeauftragte/r beim Anbieter ist:</div>
                <div>KNPP Rechts- und Patentanwälte PartGmbH</div>
                <div>Herr Igor Dragobetski</div>
              </div>
            </div>
          </div>
          <div id="II" className="flex flex-col items-start lg:flex-row gap-8">
            <div className="w-full flex flex-col gap-6">
              <div>
                <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
                  Rechte der Nutzer und Betroffenen
                </h2>
                <div>
                  Mit Blick auf die nachfolgend noch näher beschriebene
                  Datenverarbeitung haben die Nutzer und Betroffenen das Recht
                </div>
                <ul className="list-disc pl-7">
                  <li>
                    auf Bestätigung, ob sie betreffende Daten verarbeitet
                    werden, auf Auskunft über die verarbeiteten Daten, auf
                    weitere Informationen über die Datenverarbeitung sowie auf
                    Kopien der Daten (vgl. auch Art. 15 DSGVO);
                  </li>
                  <li>
                    auf Berichtigung oder Vervollständigung unrichtiger bzw.
                    unvollständiger Daten (vgl. auch Art. 16 DSGVO);
                  </li>
                  <li>
                    auf unverzügliche Löschung der sie betreffenden Daten (vgl.
                    auch Art. 17 DSGVO), oder, alternativ, soweit eine weitere
                    Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist,
                    auf Einschränkung der Verarbeitung nach Maßgabe von Art. 18
                    DSGVO;
                  </li>
                  <li>
                    auf Erhalt der sie betreffenden und von ihnen
                    bereitgestellten Daten und auf Übermittlung dieser Daten an
                    andere Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);
                  </li>
                  <li>
                    auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie
                    der Ansicht sind, dass die sie betreffenden Daten durch den
                    Anbieter unter Verstoß gegen datenschutzrechtliche
                    Bestimmungen verarbeitet werden (vgl. auch Art. 77 DSGVO).
                  </li>
                </ul>
              </div>
              <p>
                Darüber hinaus ist der Anbieter dazu verpflichtet, alle
                Empfänger, denen gegenüber Daten durch den Anbieter offengelegt
                worden sind, über jedwede Berichtigung oder Löschung von Daten
                oder die Einschränkung der Verarbeitung, die aufgrund der
                Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese
                Verpflichtung besteht jedoch nicht, soweit diese Mitteilung
                unmöglich oder mit einem unverhältnismäßigen Aufwand verbunden
                ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft
                über diese Empfänger.
              </p>
              <p className="font-bold">
                Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO
                das Recht auf Widerspruch gegen die künftige Verarbeitung der
                sie betreffenden Daten, sofern die Daten durch den Anbieter nach
                Maßgabe von Art. 6 Abs. 1 lit. f) DSGVO verarbeitet werden.
                Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum
                Zwecke der Direktwerbung statthaft.
              </p>
            </div>
          </div>
          <div id="III" className="flex flex-col items-start lg:flex-row gap-8">
            <div className="w-full">
              <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
                Informationen zur Datenverarbeitung
              </h2>
              <p>
                Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten
                werden gelöscht oder gesperrt, sobald der Zweck der Speicherung
                entfällt, der Löschung der Daten keine gesetzlichen
                Aufbewahrungspflichten entgegenstehen und nachfolgend keine
                anderslautenden Angaben zu einzelnen Verarbeitungsverfahren
                gemacht werden.
              </p>
            </div>
          </div>
          <div id="cookies" className="bg-neutral-400 w-full h-[1px]" />
          <div className="flex flex-col items-start lg:flex-row gap-8">
            <div className="w-full">
              <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
                Cookies
              </h2>
              <ul className="flex flex-col gap-12">
                <li>
                  <h3 className="font-bold mb-2">
                    a) Sitzungs-Cookies/Session-Cookies
                  </h3>
                  <div className="flex flex-col gap-4">
                    <p>
                      Wir verwenden mit unserem Internetauftritt sog. Cookies.
                      Cookies sind kleine Textdateien oder andere
                      Speichertechnologien, die durch den von Ihnen eingesetzten
                      Internet-Browser auf Ihrem Endgerät ablegt und gespeichert
                      werden. Durch diese Cookies werden im individuellen Umfang
                      bestimmte Informationen von Ihnen, wie beispielsweise Ihre
                      Browser- oder Standortdaten oder Ihre IP-Adresse,
                      verarbeitet.
                    </p>
                    <p>
                      Durch diese Verarbeitung wird unser Internetauftritt
                      benutzerfreundlicher, effektiver und sicherer, da die
                      Verarbeitung bspw. die Wiedergabe unseres
                      Internetauftritts in unterschiedlichen Sprachen oder das
                      Angebot einer Warenkorbfunktion ermöglicht.
                    </p>
                    <p>
                      Rechtsgrundlage dieser Verarbeitung ist Art. 6 Abs. 1 lit
                      b.) DSGVO, sofern diese Cookies Daten zur
                      Vertragsanbahnung oder Vertragsabwicklung verarbeitet
                      werden.
                    </p>
                    <p>
                      Falls die Verarbeitung nicht der Vertragsanbahnung oder
                      Vertragsabwicklung dient, liegt unser berechtigtes
                      Interesse in der Verbesserung der Funktionalität unseres
                      Internetauftritts. Rechtsgrundlage ist in dann Art. 6 Abs.
                      1 lit. f) DSGVO.
                    </p>
                    <p>
                      Mit Schließen Ihres Internet-Browsers werden diese
                      Session-Cookies gelöscht.
                    </p>
                  </div>
                </li>
                <li>
                  <h3 className="font-bold mb-2">b) Drittanbieter-Cookies</h3>
                  <div className="flex flex-col gap-4">
                    <p>
                      Gegebenenfalls werden mit unserem Internetauftritt auch
                      Cookies von Partnerunternehmen, mit denen wir zum Zwecke
                      der Werbung, der Analyse oder der Funktionalitäten unseres
                      Internetauftritts zusammenarbeiten, verwendet.
                    </p>
                    <p>
                      Die Einzelheiten hierzu, insbesondere zu den Zwecken und
                      den Rechtsgrundlagen der Verarbeitung solcher
                      Drittanbieter-Cookies, entnehmen Sie bitte den
                      nachfolgenden Informationen.
                    </p>
                  </div>
                </li>
                <li>
                  <h3 className="font-bold mb-2">
                    c) Beseitigungsmöglichkeit
                  </h3>
                  <div className="flex flex-col gap-4">
                    <p>
                      Sie können die Installation der Cookies durch eine
                      Einstellung Ihres Internet-Browsers verhindern oder
                      einschränken. Ebenfalls können Sie bereits gespeicherte
                      Cookies jederzeit löschen. Die hierfür erforderlichen
                      Schritte und Maßnahmen hängen jedoch von Ihrem konkret
                      genutzten Internet-Browser ab. Bei Fragen benutzen Sie
                      daher bitte die Hilfefunktion oder Dokumentation Ihres
                      Internet-Browsers oder wenden sich an dessen Hersteller
                      bzw. Support. Bei sog. Flash-Cookies kann die Verarbeitung
                      allerdings nicht über die Einstellungen des Browsers
                      unterbunden werden. Stattdessen müssen Sie insoweit die
                      Einstellung Ihres Flash-Players ändern. Auch die hierfür
                      erforderlichen Schritte und Maßnahmen hängen von Ihrem
                      konkret genutzten Flash-Player ab. Bei Fragen benutzen Sie
                      daher bitte ebenso die Hilfefunktion oder Dokumentation
                      Ihres Flash-Players oder wenden sich an den Hersteller
                      bzw. Benutzer-Support.
                    </p>
                    <p>
                      Sollten Sie die Installation der Cookies verhindern oder
                      einschränken, kann dies allerdings dazu führen, dass nicht
                      sämtliche Funktionen unseres Internetauftritts
                      vollumfänglich nutzbar sind.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-neutral-400 w-full h-[1px]" />
          <div id="contact">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Kontaktanfragen / Kontaktmöglichkeit
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Sofern Sie per Kontaktformular oder E-Mail mit uns in Kontakt
                treten, werden die dabei von Ihnen angegebenen Daten zur
                Bearbeitung Ihrer Anfrage genutzt. Die Angabe der Daten ist zur
                Bearbeitung und Beantwortung Ihre Anfrage erforderlich – ohne
                deren Bereitstellung können wir Ihre Anfrage nicht oder
                allenfalls eingeschränkt beantworten.
              </p>
              <p>
                Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. b)
                DSGVO.
              </p>
              <p>
                Ihre Daten werden gelöscht, sofern Ihre Anfrage abschließend
                beantwortet worden ist und der Löschung keine gesetzlichen
                Aufbewahrungspflichten entgegenstehen, wie bspw. bei einer sich
                etwaig anschließenden Vertragsabwicklung.
              </p>
            </div>
          </div>

          <div id="account">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Kundenkonto / Registrierungsfunktion
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Falls Sie über unseren Internetauftritt ein Kundenkonto bei uns
                anlegen, werden wir die von Ihnen bei der Registrierung
                eingegebenen Daten (also bspw. Ihren Namen, Ihre Anschrift oder
                Ihre E-Mail-Adresse) ausschließlich für vorvertragliche
                Leistungen, für die Vertragserfüllung oder zum Zwecke der
                Kundenpflege (bspw. um Ihnen eine Übersicht über Ihre bisherigen
                Bestellungen bei uns zur Verfügung zu stellen oder um Ihnen die
                sog. Merkzettelfunktion anbieten zu können) erheben und
                speichern. Gleichzeitig speichern wir dann die IP-Adresse und
                das Datum Ihrer Registrierung nebst Uhrzeit. Eine Weitergabe
                dieser Daten an Dritte erfolgt natürlich nicht.
              </p>
              <p>
                Im Rahmen des weiteren Anmeldevorgangs wird Ihre Einwilligung in
                diese Verarbeitung eingeholt und auf diese Datenschutzerklärung
                verwiesen. Die dabei von uns erhobenen Daten werden
                ausschließlich für die Zurverfügungstellung des Kundenkontos
                verwendet.
              </p>
              <p>
                Soweit Sie in diese Verarbeitung einwilligen, ist Art. 6 Abs. 1
                lit. a) DSGVO Rechtsgrundlage für die Verarbeitung.
              </p>
              <p>
                Sofern die Eröffnung des Kundenkontos zusätzlich auch
                vorvertraglichen Maßnahmen oder der Vertragserfüllung dient, so
                ist Rechtsgrundlage für diese Verarbeitung auch noch Art. 6 Abs.
                1 lit. b) DSGVO.
              </p>
              <p>
                Die uns erteilte Einwilligung in die Eröffnung und den Unterhalt
                des Kundenkontos können Sie gemäß Art. 7 Abs. 3 DSGVO jederzeit
                mit Wirkung für die Zukunft widerrufen. Hierzu müssen Sie uns
                lediglich über Ihren Widerruf in Kenntnis setzen.
              </p>
              <p>
                Die insoweit erhobenen Daten werden gelöscht, sobald die
                Verarbeitung nicht mehr erforderlich ist. Hierbei müssen wir
                aber steuer- und handelsrechtliche Aufbewahrungsfristen
                beachten.
              </p>
            </div>
          </div>
          <div id="jobs">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Online-Stellenbewerbungen / Veröffentlichung von Stellenanzeigen
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Wir bieten Ihnen die Möglichkeit an, sich bei uns über unseren
                Internetauftritt bewerben zu können. Bei diesen digitalen
                Bewerbungen werden Ihre Bewerber- und Bewerbungsdaten von uns
                zur Abwicklung des Bewerbungsverfahrens elektronisch erhoben und
                verarbeitet. Rechtsgrundlage für diese Verarbeitung ist § 26
                Abs. 1 S. 1 BDSG i.V.m. Art. 88 Abs. 1 DSGVO.
              </p>
              <p>
                Sofern nach dem Bewerbungsverfahren ein Arbeitsvertrag
                geschlossen wird, speichern wir Ihre bei der Bewerbung
                übermittelten Daten in Ihrer Personalakte zum Zwecke des
                üblichen Organisations- und Verwaltungsprozesses – dies
                natürlich unter Beachtung der weitergehenden rechtlichen
                Verpflichtungen.
              </p>
              <p>
                Rechtsgrundlage für diese Verarbeitung ist ebenfalls § 26 Abs. 1
                S. 1 BDSG i.V.m. Art. 88 Abs. 1 DSGVO. Bei der Zurückweisung
                einer Bewerbung löschen wir die uns übermittelten Daten
                automatisch zwei Monate nach der Bekanntgabe der Zurückweisung.
                Die Löschung erfolgt jedoch nicht, wenn die Daten aufgrund
                gesetzlicher Bestimmungen, bspw. wegen der Beweispflichten nach
                dem AGG, eine längere Speicherung von bis zu vier Monaten oder
                bis zum Abschluss eines gerichtlichen Verfahrens erfordern.
              </p>
              <p>
                Rechtsgrundlage ist in diesem Fall Art. 6 Abs. 1 lit. f) DSGVO
                und § 24 Abs. 1 Nr. 2 BDSG. Unser berechtigtes Interesse liegt
                in der Rechtsverteidigung bzw. -durchsetzung.
              </p>
              <p>
                Sofern Sie ausdrücklich in eine längere Speicherung Ihrer Daten
                einwilligen, bspw. für Ihre Aufnahme in eine Bewerber- oder
                Interessentendatenbank, werden die Daten aufgrund Ihrer
                Einwilligung weiterverarbeitet. Rechtsgrundlage ist dann Art. 6
                Abs. 1 lit. a) DSGVO. Ihre Einwilligung können Sie aber
                natürlich jederzeit nach Art. 7 Abs. 3 DSGVO durch Erklärung uns
                gegenüber mit Wirkung für die Zukunft widerrufen.
              </p>
            </div>
          </div>
          <div id="server">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Serverdaten
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Aus technischen Gründen, insbesondere zur Gewährleistung eines
                sicheren und stabilen Internetauftritts, werden Daten durch
                Ihren Internet-Browser an uns bzw. an unseren Webspace-Provider
                übermittelt. Mit diesen sog. Server-Logfiles werden u.a. Typ und
                Version Ihres Internetbrowsers, das Betriebssystem, die Website,
                von der aus Sie auf unseren Internetauftritt gewechselt haben
                (Referrer URL), die Website(s) unseres Internetauftritts, die
                Sie besuchen, Datum und Uhrzeit des jeweiligen Zugriffs sowie
                die IP-Adresse des Internetanschlusses, von dem aus die Nutzung
                unseres Internetauftritts erfolgt, erhoben.
              </p>
              <p>
                Diese so erhobenen Daten werden vorrübergehend gespeichert, dies
                jedoch nicht gemeinsam mit anderen Daten von Ihnen.
              </p>
              <p>
                Diese Speicherung erfolgt auf der Rechtsgrundlage von Art. 6
                Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der
                Verbesserung, Stabilität, Funktionalität und Sicherheit unseres
                Internetauftritts. Die Daten werden spätestens nach sieben Tage
                wieder gelöscht, soweit keine weitere Aufbewahrung zu
                Beweiszwecken erforderlich ist. Andernfalls sind die Daten bis
                zur endgültigen Klärung eines Vorfalls ganz oder teilweise von
                der Löschung ausgenommen.
              </p>
            </div>
          </div>
          <div id="linkedin">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              LinkedIn
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Wir unterhalten bei LinkedIn eine Onlinepräsenz um unser
                Unternehmen sowie unsere Leistungen zu präsentieren und mit
                Kunden/Interessenten zu kommunizieren. LinkedIn ist ein Service
                der LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton
                Place, Dublin 2, Irland, ein Tochterunternehmen der LinkedIn
                Corporation, 1000 W. Maude Avenue, Sunnyvale, CA 94085, USA.
              </p>
              <p>
                Insofern weisen wir darauf hin, dass die Möglichkeit besteht,
                dass Daten der Nutzer außerhalb der Europäischen Union,
                insbesondere in den USA, verarbeitet werden. Hierdurch können
                gesteigerte Risiken für die Nutzer insofern bestehen, als dass
                z.B. der spätere Zugriff auf die Nutzerdaten erschwert werden
                kann. Auch haben wir keinen Zugriff auf diese Nutzerdaten. Die
                Zugriffsmöglichkeit liegt ausschließlich bei LinkedIn.
              </p>
              <div>
                <p>Die Datenschutzhinweise von LinkedIn finden Sie unter</p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.linkedin.com/legal/privacy-policy"
                >
                  https://www.linkedin.com/legal/privacy-policy
                </a>
              </div>
            </div>
          </div>

          <div id="analytics">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Google Analytics
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                In unserem Internetauftritt setzen wir Google Analytics ein.
                Hierbei handelt es sich um einen Webanalysedienst der Google
                Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland,
                nachfolgend nur „Google“ genannt.
              </p>
              <p>
                Der Dienst Google Analytics dient zur Analyse des
                Nutzungsverhaltens unseres Internetauftritts. Rechtsgrundlage
                ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse
                liegt in der Analyse, Optimierung und dem wirtschaftlichen
                Betrieb unseres Internetauftritts.
              </p>
              <p>
                Nutzungs- und nutzerbezogene Informationen, wie bspw.
                IP-Adresse, Ort, Zeit oder Häufigkeit des Besuchs unseres
                Internetauftritts, werden dabei an einen Server von Google in
                den USA übertragen und dort gespeichert. Allerdings nutzen wir
                Google Analytics mit der sog. Anonymisierungsfunktion. Durch
                diese Funktion kürzt Google die IP-Adresse schon innerhalb der
                EU bzw. des EWR.
              </p>
              <p>
                Die so erhobenen Daten werden wiederum von Google genutzt, um
                uns eine Auswertung über den Besuch unseres Internetauftritts
                sowie über die dortigen Nutzungsaktivitäten zur Verfügung zu
                stellen. Auch können diese Daten genutzt werden, um weitere
                Dienstleistungen zu erbringen, die mit der Nutzung unseres
                Internetauftritts und der Nutzung des Internets zusammenhängen.
              </p>
              <div>
                <p>
                  Google gibt an, Ihre IP-Adresse nicht mit anderen Daten zu
                  verbinden. Zudem hält Google unter
                </p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.google.com/intl/de/policies/privacy/partners"
                >
                  https://www.google.com/intl/de/policies/privacy/partners
                </a>
              </div>
              <p>
                weitere datenschutzrechtliche Informationen für Sie bereit, so
                bspw. auch zu den Möglichkeiten, die Datennutzung zu
                unterbinden.
              </p>
              <div>
                <p>Zudem bietet Google unter</p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://tools.google.com/dlpage/gaoptout?hl=de"
                  className="link-primary"
                >
                  https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
              </div>
              <p>
                ein sog. Deaktivierungs-Add-on nebst weiteren Informationen
                hierzu an. Dieses Add-on lässt sich mit den gängigen
                Internet-Browsern installieren und bietet Ihnen weitergehende
                Kontrollmöglichkeit über die Daten, die Google bei Aufruf
                unseres Internetauftritts erfasst. Dabei teilt das Add-on dem
                JavaScript (ga.js) von Google Analytics mit, dass Informationen
                zum Besuch unseres Internetauftritts nicht an Google Analytics
                übermittelt werden sollen. Dies verhindert aber nicht, dass
                Informationen an uns oder an andere Webanalysedienste
                übermittelt werden. Ob und welche weiteren Webanalysedienste von
                uns eingesetzt werden, erfahren Sie natürlich ebenfalls in
                dieser Datenschutzerklärung.
              </p>
            </div>
          </div>
          <div id="cloudflare">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              CloudFlare
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Zur Absicherung unseres Internetauftritts sowie zur Optimierung
                der Ladezeiten setzen wir den Dienst CloudFlare als sog. CDN
                (Content-Delivery-Network) ein. Es handelt sich hierbei um einen
                Dienst der Cloudflare Inc., 101 Townsend Street, San Francisco,
                California 94107, USA, nachfolgend nur „CloudFlare“ genannt.
              </p>
              <p>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser
                berechtigtes Interesse liegt in dem sicheren Betrieb unseres
                Internetauftritts sowie in dessen Optimierung.
              </p>
              <div>
                Sofern Sie unseren Internetauftritt aufrufen, werden Ihre
                Anfragen über den Server von CloudFlare geleitet. Hierbei werden
                statistische Zugriffsdaten über den Besuch unseres
                Internetauftritts erhoben und durch CloudFlare ein Cookie über
                Ihren Internet-Browser auf Ihrem Endgerät gespeichert. Zu den
                Zugriffsdaten zählen
                <ul>
                  <li>- Ihre IP-Adresse,</li>
                  <li>
                    – die von Ihnen aufgerufene(n) Internetseite(n) unseres
                    Internetauftritts,
                  </li>
                  <li>
                    – Typ und Version des von Ihnen genutzten Internet –
                    Browsers,
                  </li>
                  <li>– das von Ihnen genutzte Betriebssystem,</li>
                  <li>
                    – die Internetseite, von der sie auf unseren
                    Internetauftritt gewechselt haben (Referrer- URL),
                  </li>
                  <li>– Ihre Verweildauer auf unserem Internetauftritt und</li>
                  <li>– die Häufigkeit des Aufrufs unserer Internetseiten.</li>
                </ul>
              </div>
              <p>
                Die Daten werden durch CloudFlare zum Zwecke statistischer
                Auswertungen der Zugriffe sowie zur Sicherheit und Optimierung
                des Angebots verwendet. Sofern Sie mit dieser Verarbeitung nicht
                einverstanden sind, haben Sie die Möglichkeit, die Installation
                der Cookies durch die entsprechenden Einstellungen in Ihrem
                Internet-Browser zu verhindern. Einzelheiten hierzu finden Sie
                vorstehend unter dem Punkt „Cookies“.
              </p>
              <div>
                <p>CloudFlare bietet unter</p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.cloudflare.com/privacypolicy/"
                >
                  https://www.cloudflare.com/privacypolicy/
                </a>
              </div>
              <p>
                weitere Informationen zur Erhebung und Nutzung der Daten sowie
                zu Ihren Rechten und Möglichkeiten zum Schutz Ihrer Privatsphäre
                an.
              </p>
            </div>
          </div>
          <div id="fonts">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Google Fonts
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                In unserem Internetauftritt setzen wir Google Fonts zur
                Darstellung externer Schriftarten ein. Es handelt sich hierbei
                um einen Dienst der Google Ireland Limited, Gordon House, Barrow
                Street, Dublin 4, Irland, nachfolgend nur „Google“ genannt.
              </p>
              <p>
                Um die Darstellung bestimmter Schriften in unserem
                Internetauftritt zu ermöglichen, wird bei Aufruf unseres
                Internetauftritts eine Verbindung zu dem Google-Server in den
                USA aufgebaut. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO.
                Unser berechtigtes Interesse liegt in der Optimierung und dem
                wirtschaftlichen Betrieb unseres Internetauftritts.
              </p>
              <p>
                Durch die bei Aufruf unseres Internetauftritts hergestellte
                Verbindung zu Google kann Google ermitteln, von welcher Website
                Ihre Anfrage gesendet worden ist und an welche IP-Adresse die
                Darstellung der Schrift zu übermitteln ist.
              </p>
              <div>
                <p>Google bietet unter</p>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="link-primary"
                      href="https://adssettings.google.com/authenticated"
                    >
                      https://adssettings.google.com/authenticated
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="link-primary"
                      href="https://policies.google.com/privacy"
                    >
                      https://policies.google.com/privacy
                    </a>
                  </li>
                </ul>
                <p>
                  weitere Informationen an und zwar insbesondere zu den
                  Möglichkeiten der Unterbindung der Datennutzung.
                </p>
              </div>
            </div>
          </div>
          <div id="maps">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Google Maps
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                In unserem Internetauftritt setzen wir Google Maps zur
                Darstellung unseres Standorts sowie zur Erstellung einer
                Anfahrtsbeschreibung ein. Es handelt sich hierbei um einen
                Dienst der Google Ireland Limited, Gordon House, Barrow Street,
                Dublin 4, Irland, nachfolgend nur „Google“ genannt. Um die
                Darstellung bestimmter Schriften in unserem Internetauftritt zu
                ermöglichen, wird bei Aufruf unseres Internetauftritts eine
                Verbindung zu dem Google-Server in den USA aufgebaut.
              </p>
              <p>
                Sofern Sie die in unseren Internetauftritt eingebundene
                Komponente Google Maps aufrufen, speichert Google über Ihren
                Internet-Browser ein Cookie auf Ihrem Endgerät. Um unseren
                Standort anzuzeigen und eine Anfahrtsbeschreibung zu erstellen,
                werden Ihre Nutzereinstellungen und -daten verarbeitet. Hierbei
                können wir nicht ausschließen, dass Google Server in den USA
                einsetzt. Im Falle einer von Ihnen erteilten Einwilligung für
                diese Verarbeitung ist Rechtsgrundlage Art. 6 Abs. 1 lit. a
                DSGVO. Rechtsgrundlage kann auch Art. 6 Abs. 1 lit. f DSGVO
                sein. Unser berechtigtes Interesse liegt in der Optimierung der
                Funktionalität unseres Internetauftritts.
              </p>
              <p>
                Durch die so hergestellte Verbindung zu Google kann Google
                ermitteln, von welcher Website Ihre Anfrage gesendet worden ist
                und an welche IP-Adresse die Anfahrtsbeschreibung zu übermitteln
                ist.
              </p>
              <p>
                Sofern Sie mit dieser Verarbeitung nicht einverstanden sind,
                haben Sie die Möglichkeit, die Installation der Cookies durch
                die entsprechenden Einstellungen in Ihrem Internet-Browser zu
                verhindern. Einzelheiten hierzu finden Sie vorstehend unter dem
                Punkt „Cookies“.
              </p>
              <p>
                Zudem erfolgt die Nutzung von Google Maps sowie der über Google
                Maps erlangten Informationen nach den Google-Nutzungsbedingungen{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://policies.google.com/terms?gl=DE&hl=de "
                >
                  https://policies.google.com/terms?gl=DE&hl=de
                </a>{" "}
                und den Geschäftsbedingungen für Google Maps{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.google.com/intl/de_de/help/terms_maps.html."
                >
                  https://www.google.com/intl/de_de/help/terms_maps.html.
                </a>
              </p>
              <div>
                <p>Überdies bietet Google unter</p>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="link-primary"
                      href="https://adssettings.google.com/authenticated"
                    >
                      https://adssettings.google.com/authenticated
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="link-primary"
                      href="https://policies.google.com/privacy"
                    >
                      https://policies.google.com/privacy
                    </a>
                  </li>
                </ul>
                <p>weitergehende Informationen an.</p>
              </div>
            </div>
          </div>
          <div id="mapbox">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              Mapbox API
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Für Anfahrtsbeschreibungen setzen wir Mapbox API, einen Dienst
                der Mapbox Inc., 740 15th Street NW, 5 th Floor, Washington,
                District of Columbia 20005, USA, nachfolgend nur „Mapbox“
                genannt, ein. Im Falle einer von Ihnen erteilten Einwilligung
                für diese Verarbeitung ist Rechtsgrundlage Art. 6 Abs. 1 lit. a
                DSGVO. Rechtsgrundlage kann auch Art. 6 Abs. 1 lit. f DSGVO
                sein. Unser berechtigtes Interesse liegt in der Optimierung der
                Funktionalität unseres Internetauftritts.
              </p>
              <p>
                Bei Aufruf einer unserer Internetseiten, in die der Dienst
                Mapbox eingebunden ist, wird durch Mapbox ein Cookie über Ihren
                Internet – Browser auf Ihrem Endgerät gespeichert. Hierdurch
                werden Informationen über Ihre Nutzung unseres
                Internetauftritts, einschließlich Ihrer IP- Adresse, an einen
                Server von Mapbox in den USA übertragen und dort gespeichert.
                Diese Daten werden zum Zwecke der Anzeige der Seite bzw. zur
                Gewährleistung der Funktionalität des Dienstes Mapbox
                verarbeitet. Diese Informationen wird Mapbox womöglich an Dritte
                weitergeben, sofern dies gesetzlich vorgeschrieben ist oder die
                Informationen durch Dritte im Auftrag von Mapbox verarbeitet
                werden. Die „Terms of Service“, die durch Mapbox unter
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.mapbox.com/tos/#maps bereitgestellt"
                >
                  https://www.mapbox.com/tos/#maps bereitgestellt
                </a>{" "}
                werden, enthalten weitergehenden Informationen über die Nutzung
                von Mapbox und über die von Mapbox erlangten Daten.
              </p>
              <p>
                Sofern Sie mit dieser Verarbeitung nicht einverstanden sind,
                haben Sie die Möglichkeit, die Installation der Cookies durch
                die entsprechenden Einstellungen in Ihrem Internet -Browser zu
                verhindern. Einzelheiten hierzu finden Sie vorstehend unter dem
                Punkt „Cookies“. Die Nutzung des Dienstes Mapbox über unseren
                Internetauftritt ist dann allerdings nicht mehr möglich.
              </p>
              <div>
                <p>Zudem bietet Mapbox unter</p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://www.mapbox.com/privacy/"
                >
                  https://www.mapbox.com/privacy/
                </a>
                <p>
                  weitere Informationen zur Erhebung und Nutzung der Daten sowie
                  zu Ihren Rechten und Möglichkeiten zum Schutz Ihrer
                  Privatsphäre an.
                </p>
              </div>
            </div>
          </div>
          <div id="osm">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              OpenStreetMap
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                Für Anfahrtsbeschreibungen setzen wir OpenStreetMap, einen
                Dienst der OpenStreetMap Foundation, St John’s Innovation
                Centre, Cowley Road, Cambridge, CB 4 0 WS, United Kingdom,
                nachfolgend nur „OpenStreetMap“ genannt, ein.
              </p>
              <p>
                Bei Aufruf einer unserer Internetseiten, in die der Dienst
                OpenStreetMap eingebunden ist, wird durch OpenStreetMap ein
                Cookie über Ihren Internet-Browser auf Ihrem Endgerät
                gespeichert. Hierdurch werden Ihre Nutzereinstellungen und
                Nutzerdaten zum Zwecke der Anzeige der Seite bzw. zur
                Gewährleistung der Funktionalität des Dienstes OpenStreetMap
                verarbeitet. Durch diese Verarbeitung kann OpenStreetMap
                erkennen, von welcher Internetseite Ihre Anfrage gesendet worden
                ist und an welche IP- Adresse die Darstellung der Anfahrt
                übermittelt werden soll. Im Falle einer von Ihnen erteilten
                Einwilligung für diese Verarbeitung ist Rechtsgrundlage Art. 6
                Abs. 1 lit. a DSGVO. Rechtsgrundlage kann auch Art. 6 Abs. 1
                lit. f DSGVO sein. Unser berechtigtes Interesse liegt in der
                Optimierung und dem wirtschaftlichen Betrieb unseres
                Internetauftritts. Sofern Sie mit dieser Verarbeitung nicht
                einverstanden sind, haben Sie die Möglichkeit, die Installation
                der Cookies durch die entsprechenden Einstellungen in Ihrem
                Internet-Browser zu verhindern. Einzelheiten hierzu finden Sie
                vorstehend unter dem Punkt „Cookies“.
              </p>
              <div>
                <p>OpenStreetMap bietet unter</p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary"
                  href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
                >
                  https://wiki.osmfoundation.org/wiki/Privacy_Policy
                </a>
                <p>
                  weitere Informationen zur Erhebung und Nutzung der Daten sowie
                  zu Ihren Rechten und Möglichkeiten zum Schutz Ihrer
                  Privatsphäre an.
                </p>
              </div>
            </div>
          </div>
          <div id="whatsapp">
            <h2 className="font-bold text-[20px] leading-[160%] mb-6 text-[#031F47]">
              WhatsApp
            </h2>
            <div className="w-full flex flex-col gap-6">
              <p>
                We use WhatsApp as a communication channel on our website to
                facilitate customer support and address inquiries promptly. We
                collect your phone number to initiate WhatsApp conversations
                with you. The messages sent and received during these
                interactions are stored securely and are used for the purpose of
                providing customer support. We may also share this information
                with third-party customer support platforms to enhance our
                communication and service delivery. You can manage your WhatsApp
                privacy settings to control who can see your profile and how
                it&aposs used. You can also withdraw your consent for data
                collection by contacting us at kontakt@omto.de or through the
                WhatsApp settings on your device.
              </p>
            </div>
          </div>
          <div id="source">
            <div className="w-full flex flex-col">
              <p>
                Diese Datenschutzerklärung wurde in Teilen mit dem Generator von ratgeberrecht.eu
                des Anbieters Anwaltskanzlei Weiß & Partner Rechtsanwälte, Patentanwalt
                Katharinenstraße 16 73728 Esslingen, erstellt.
              </p>
                <p>
                <a
                    target="_blank"
                    rel="noreferrer"
                    className="link-primary"
                    href="https://www.xn--generator-datenschutzerklrung-pqc.de/"
                >Muster-Datenschutzerklärung</a> der <a
                    target="_blank"
                    rel="noreferrer"
                    className="link-primary"
                    href="https://www.xn--bewertung-lschen24-n3b.de/"
                >Anwaltskanzlei Weiß & Partner</a>
              </p>
            </div>
          </div>
    </DocumentLayout>
  );
};

export default PrivacyPolicy;
